import { render, staticRenderFns } from "./ExtrasRegister.vue?vue&type=template&id=d4ae9f8c&scoped=true&"
import script from "./ExtrasRegister.vue?vue&type=script&lang=js&"
export * from "./ExtrasRegister.vue?vue&type=script&lang=js&"
import style0 from "./ExtrasRegister.vue?vue&type=style&index=0&id=d4ae9f8c&prod&scoped=true&lang=css&"
import style1 from "./ExtrasRegister.vue?vue&type=style&index=1&id=d4ae9f8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ae9f8c",
  null
  
)

export default component.exports